import {reactive, unref} from 'vue'

import {store} from './Store';
import {getSafeDomainData} from '../classes/implementation/Config';
import * as _ from "lodash"

const URL_SUFFIX = ""

export function getAPIurlPrefix() {
    return store.apiUrl;
}

export const urls = reactive({
    coinListUrl: () => '/crypto-icons/manifest.json',
    positionsUrl: (orderSource) => getAPIurlPrefix() + '/protected/' + orderSource + '/openPositions' + URL_SUFFIX,
});

export const loaders = reactive({
    async loadCoins() {
        store.tokenStatus = 'Loading...';
        try {
            const res = await fetch(urls.coinListUrl());
            store.tokenList = (await res.json());
            store.tokenStatus = 'Ready; ' + store.tokenList.length + ' coins loaded';
            let count = 0;
            for (let coin of store.tokenList) {
                coin.ID = count++;
                store.tokenDict[coin.ID] = coin;
                store.tokenIDs[coin.symbol] = coin;
            }
        }
        catch (error) {
            store.tokenStatus = 'Error! Could not reach the API ' + error
        }
    },
    injectToken(token) {
        if (!(token in store.tokenIDs)) {
            let count = store.tokenList.length;
            let coin = {
                "ID": count++,
                "symbol": token,
                "name": token,
                "color": "#000000"
            }
            store.tokenDict[coin.ID] = coin;
            store.tokenIDs[coin.symbol] = coin;
            store.tokenList.push(coin);
        }
    },
    injectCoins() {
        for (let instrument of store.instrumentList) {
            this.injectToken(instrument.baseSymbol, instrument);
            this.injectToken(instrument.quoteSymbol, instrument);
        }
    },
    async getInfo() {
        const configEntries = store.config
        var chainsSupported = {}
        var chainsList: string[] = configEntries.supportedChains as unknown as string[]
        if (!store.walletIsConnected) {
        }
        store.tokenToAssetMap = {};
        for (var chainId in chainsList) {
            var chain = chainsList[chainId]
            var srcPlaceHolder = "{source}"
            try {
                const res = await fetch(configEntries.assetTokenInfo.split(srcPlaceHolder).join(chain));
                if (res.status == 200) {
                    var chainAssets = await res.json()
                    if (!_.isEmpty(chainAssets.tokenInfoResponses || [])) {
                        chainsSupported[chain] = chainsSupported[chain] || {}
                        chainsSupported[chain]["tokenInfoResponses"] = chainAssets.tokenInfoResponses.flatMap(item => item.tokens);

                      chainAssets.tokenInfoResponses.forEach(item => {
                        item.tokens.forEach(tokenObj => {
                          if (!store.tokenToAssetMap[tokenObj.token]) {
                            store.tokenToAssetMap[tokenObj.token] = item.asset;
                          }
                        });
                      });
                    }
                }
            }
            catch (err) {
                console.log("to-be-ignored", err)
            }
        }

        var infoObj = {
            info: {
                supportedChains: [],
                domain: configEntries.siweDomain || configEntries.domain,
                featureToggles: {},
                limitBasisPointRecommendation: 25,
            },
            status: "OPEN"
        }
        var abiDefaults = getSafeDomainData(`abi`)
        for (var chain in chainsSupported) {
            var chainObj = chainsSupported[chain]
            var env = configEntries.env;
            var abiDefaultsToUse = getSafeDomainData(`abi_${env}_${chain}`) || getSafeDomainData(`abi_${chain}`) || abiDefaults
            var chainDefaults = getSafeDomainData(`chain_${env}_${chain}`) || getSafeDomainData(`chain_${chain}`)
            var chainInstruments = []


            var iId = 0;

            for (var i in chainObj.tokenInfoResponses) {
                var idx = parseInt(i)
                for (var j: number = idx; j < chainObj.tokenInfoResponses.length; j++) {
                    if (idx != j) {
                        var baseSymbolDetails = chainObj.tokenInfoResponses[i]
                        var quoteSymbolDetails = chainObj.tokenInfoResponses[j]
                        iId++;
                        var origBaseSymbol = baseSymbolDetails.token
                        var origQuoteSymbol = quoteSymbolDetails.token
                        var baseSymbol = _.toUpper(origBaseSymbol)
                        var quoteSymbol = _.toUpper(origQuoteSymbol)

                        var instrument = {
                            "instrumentId": iId,
                            "baseSymbol": baseSymbol,
                            "origBaseSymbol": origBaseSymbol,
                            "origQuoteSymbol": origQuoteSymbol,
                            "baseContractAddress": baseSymbolDetails.tokenAddress,
                            "baseDecimals": parseInt(baseSymbolDetails.decimals),
                            "quoteSymbol": quoteSymbol,
                            "quoteContractAddress": quoteSymbolDetails.tokenAddress,
                            "quoteDecimals": parseInt(quoteSymbolDetails.decimals),
                            "maxLeverage": "1"
                        }
                        chainInstruments.push(instrument);
                    }
                }
            }
            let instrumentId1Index;
            let wannaBeNumber1Index;
            for (var instrumentIndex in chainInstruments)
            {
                const dodgyIns = chainInstruments[instrumentIndex];
                if (dodgyIns.instrumentId === 1)
                {
                    instrumentId1Index = instrumentIndex;
                }
                if ((dodgyIns.baseSymbol.startsWith("ETH") && dodgyIns.quoteSymbol.startsWith("USDC")) || (dodgyIns.baseSymbol.startsWith("USDC") && dodgyIns.quoteSymbol.startsWith("ETH")))
                {
                    wannaBeNumber1Index = instrumentIndex;
                }
            }

            if (instrumentId1Index && wannaBeNumber1Index)
            {
                chainInstruments[instrumentId1Index].instrumentId = chainInstruments[wannaBeNumber1Index].instrumentId;
                chainInstruments[wannaBeNumber1Index].instrumentId = 1;
            }

            var chainInfo = {
                label: chain,
                chainId: chainDefaults["chainId"] || "",
                rpcUrl: chainDefaults["rpcUrl"] || "",
                txExplorerUrl: chainDefaults["txExplorerUrl"] || "",
                token: chainDefaults["token"] || "",
                smartContractAddress: chainDefaults["smartContractAddress"] || "",
                dtwContractAddress: chainDefaults["dtwContractAddress"] || "",
                wethContractAddress: chainDefaults["wethContractAddress"] || "",
                whitelistSmartContractAddress: chainDefaults["whitelistSmartContractAddress"] || "",
                liquidityPoolSmartContractAddress: chainDefaults["liquidityPoolSmartContractAddress"] || "",
                leverageSmartContractAddress: chainDefaults["leverageSmartContractAddress"] || "",
                smartContractFeePercentage: chainDefaults["smartContractFeePercentage"] || "",
                refundDurationSeconds: chainDefaults["refundDurationSeconds"] || "",
                abi: abiDefaultsToUse["abi"] || "",
                dtwABI: abiDefaultsToUse["dtwABI"] || "",
                whitelistABI: abiDefaultsToUse["whitelistABI"] || "",
                leverageABI: abiDefaultsToUse["leverageABI"] || "",
                instruments: chainInstruments,
            }
            infoObj.info.supportedChains.push(chainInfo)
        }
        return infoObj


    },
    async loadInstruments() {
        if (store.tokenList.length == 0) {
            await this.loadCoins();
        }
        store.instrumentStatus = 'Loading...';
        try {
            var infoObj = await this.getInfo()
            store.backendInfo = infoObj.info || {}
            const chainInfo = store.getChainInfo();
            store.instrumentList = unref(chainInfo.instruments).filter(instrument => instrument.baseSymbol.toUpperCase() != "XAU" && instrument.quoteSymbol.toUpperCase() != "XAU");
            this.injectCoins();
            try {
                let ethscanPrefix = unref(chainInfo.txExplorerUrl);
                if (ethscanPrefix) {
                    store.ethscanPrefix = ethscanPrefix;
                }
                store.domainForSIWE = unref((store.backendInfo as any).domain);
            }
            catch (e) {
                console.log('ERROR, failed to load all info from /info endpoint', e);
                store.instrumentStatus = 'Error...';
            }

            if (store.instrumentList.length > 0) {
                for (let instrument of store.instrumentList) {
                    if (instrument.maxLeverage > 1) {
                        if (instrument.baseSymbol == "btc") {
                            instrument.baseSymbol = "wBTC";
                        } else if (instrument.baseSymbol == "eth") {
                            instrument.baseSymbol = "ETH";
                        }
                        store.instrumentDict["lev_" + instrument.instrumentId] = instrument;
                        store.instrumentOrigMapping[instrument.origBaseSymbol] = instrument.baseSymbol
                        store.instrumentOrigMapping[instrument.baseSymbol] = instrument.origBaseSymbol

                        store.instrumentOrigMapping[instrument.origQuoteSymbol] = instrument.quoteSymbol
                        store.instrumentOrigMapping[instrument.quoteSymbol] = instrument.origQuoteSymbol

                        store.instrumentPairs["lev_" + instrument.baseSymbol + '/' + instrument.quoteSymbol] = {
                            id: instrument.instrumentId,
                            inverted: false
                        };
                        store.instrumentPairs["lev_" + instrument.quoteSymbol + '/' + instrument.baseSymbol] = {
                            id: instrument.instrumentId,
                            inverted: true
                        };
                    } else {
                        store.instrumentDict[instrument.instrumentId] = instrument;
                        store.tokenAddresses[instrument.baseSymbol] = instrument.baseContractAddress;
                        store.tokenAddresses[instrument.quoteSymbol] = instrument.quoteContractAddress;
                        store.tokenDPs[instrument.baseSymbol] = instrument.baseDecimals;
                        store.tokenDPs[instrument.quoteSymbol] = instrument.quoteDecimals;

                        store.instrumentOrigMapping[instrument.origBaseSymbol] = instrument.baseSymbol
                        store.instrumentOrigMapping[instrument.baseSymbol] = instrument.origBaseSymbol

                        store.instrumentOrigMapping[instrument.origQuoteSymbol] = instrument.quoteSymbol
                        store.instrumentOrigMapping[instrument.quoteSymbol] = instrument.origQuoteSymbol

                        store.instrumentPairs[instrument.baseSymbol + '/' + instrument.quoteSymbol] = {
                            id: instrument.instrumentId,
                            instrument: instrument,
                            inverted: false
                        };
                        store.instrumentPairs[instrument.quoteSymbol + '/' + instrument.baseSymbol] = {
                            id: instrument.instrumentId,
                            instrument: instrument,
                            inverted: true
                        };
                        if (instrument.instrumentId === 1) {
                            if (instrument.baseSymbol.startsWith("USDC") && instrument.quoteSymbol.startsWith("ETH"))
                            {
                                store.frontToken = instrument.quoteSymbol;
                                store.balanceToken = instrument.quoteSymbol;
                                store.backToken = instrument.baseSymbol;
                            }
                            else
                            {
                                store.frontToken = instrument.baseSymbol;
                                store.balanceToken = instrument.baseSymbol;
                                store.backToken = instrument.quoteSymbol;
                            }
                        }
                    }

                    store.instrumentTokens[instrument.baseSymbol] = true;
                    store.instrumentTokens[instrument.quoteSymbol] = true;
                }
                // mdservices.startChartData();
            }
            else {
                store.instrumentStatus = 'Error! No instruments loaded';
                console.log(store.instrumentStatus);
            }
            console.log('tokenDPs', store.tokenDPs);
            console.log('instrumentTokens', store.instrumentTokens);
            console.log('instrumentAddresses', store.tokenAddresses);
            console.log('instrumentDict', store.instrumentDict);
            console.log('instrumentPairs', store.instrumentPairs);
        }
        catch (error) {
            store.instrumentStatus = 'Error! Could not load instruments: ' + error
            console.log(store.instrumentStatus);
        }
    }
});

